import IndustryWiseMemberChart from "./QuickLinks&Industry/LinkCards";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import EcommerceMetrix from "components/cards/statistics/EcommerceMetrix";
import {
  CheckOutlined,
  CloseOutlined,
  QuestionOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { IMemberStatusResult } from "../api/types";
import { GetMembers } from "../api/hooks";

const GeneralCard = () => {
  function formatNumberWithCommas(num?: number) {
    return num?.toLocaleString();
  }

  const [filterModel, setFilterModel] = useState({
    filter: {
      fromDate: null,
      toDate: null,
    },
  });

  const [data, setData] = useState<IMemberStatusResult>();

  const memberQuery = GetMembers(filterModel);

  useEffect(() => {
    if (memberQuery.data?.status === 200) {
      setData(memberQuery?.data?.apiData);
    }
  }, [memberQuery.data]);

  return (
    <>
      <Grid container spacing={3} sx={{ mb: 1 }}>
        <Grid item xl={8} lg={8} md={8} sm={8} xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
              <EcommerceMetrix
                primary="Total Members"
                secondary={formatNumberWithCommas(
                  data?.memberTotalCountResult?.totalMember
                    ? data?.memberTotalCountResult?.totalMember
                    : 0
                )}
                color="primary.main"
                iconPrimary={TeamOutlined}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
              <EcommerceMetrix
                primary="Approved Members"
                secondary={formatNumberWithCommas(
                  data?.memberChartResult?.approved_Members
                    ? data?.memberChartResult?.approved_Members
                    : 0
                )}
                color="success.main"
                iconPrimary={CheckOutlined}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
              <EcommerceMetrix
                primary="Not Approved Members"
                secondary={formatNumberWithCommas(
                  data?.memberChartResult?.rejected_Members
                    ? data?.memberChartResult?.rejected_Members
                    : 0
                )}
                color="error.main"
                iconPrimary={CloseOutlined}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
              <EcommerceMetrix
                primary="Pending Members"
                secondary={formatNumberWithCommas(
                  data?.memberChartResult?.pending_Members
                    ? data?.memberChartResult?.pending_Members
                    : 0
                )}
                color="#ff9800"
                iconPrimary={QuestionOutlined}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
          <IndustryWiseMemberChart />
        </Grid>
      </Grid>
    </>
  );
};

export default GeneralCard;
